import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const PartnerbedingungenPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Partnerbedingungen - Dein Gutachten Direkt</title>
        <meta name="robots" content="index, follow" />
      </Helmet>
      
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl font-bold text-gray-900 mb-12">Partnerbedingungen (Partnerprogramm) – v1.0</h1>
          
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 mb-12">
            <p className="text-gray-700 mb-4">
              Diese Partnerbedingungen regeln die Zusammenarbeit zwischen der Dein-Gutachten-Direkt GbR („Anbieter") und dem jeweiligen Partner („Partner"), der über das Portal Fälle einreicht oder vermittelt.
            </p>
            <p className="text-gray-700">
              Sie gelten zusätzlich zu den AGB und der Datenschutzerklärung.
            </p>
          </div>
          
          {/* 1. Begriffe und Rolle */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Begriffe und Rolle</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-2">
                <li>Der Partner ist ein selbstständiger Vermittler/Kooperationspartner und kein Mitarbeiter des Anbieters.</li>
                <li>Der Anbieter erstellt Unfallgutachten und übernimmt die interne Bearbeitung.</li>
                <li>Der Partner ist verantwortlich für die Erfassung, Übermittlung und Richtigkeit der übermittelten Angaben, Fotos und Dokumente.</li>
              </ol>
            </div>
          </section>
          
          {/* 2. Zugang zum Portal */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Zugang zum Portal</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-2">
                <li>Der Portalzugang ist personenbezogen und darf nicht an Dritte weitergegeben werden.</li>
                <li>Der Partner schützt seine Zugangsdaten und informiert den Anbieter bei Verdacht auf Missbrauch.</li>
                <li>Der Anbieter darf Zugänge sperren, wenn ein Missbrauch vermutet wird oder Vertragsverstöße vorliegen.</li>
              </ol>
            </div>
          </section>
          
          {/* 3. Abonnement */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Abonnement und Zugangsvoraussetzung</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-2">
                <li>Der Portalzugang ist mit einem monatlichen Abonnement verbunden (Starter: 29,99 EUR, Pro: 49,99 EUR, Premium: 79,99 EUR inkl. MwSt.).</li>
                <li>Der Zugang wird nach erfolgreicher Zahlung freigeschaltet.</li>
                <li>Der Anbieter kann Leistungen sperren, wenn Zahlungen ausbleiben.</li>
              </ol>
            </div>
          </section>
          
          {/* 4. Einreichung von Fällen */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Einreichung von Fällen: Pflicht zur Wahrheit und Vollständigkeit</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-2">
                <li>Der Partner übermittelt nur Fälle, bei denen er nach bestem Wissen richtige Angaben macht.</li>
                <li>Vorschäden, Reparaturen und bekannte Besonderheiten müssen angegeben werden.</li>
                <li>Manipulierte oder irreführende Fotos sind untersagt.</li>
                <li>Fehlen wesentliche Angaben, kann der Anbieter Rückfragen stellen oder die Bearbeitung pausieren.</li>
              </ol>
            </div>
          </section>
          
          {/* 5. Einwilligungen */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Einwilligungen und Berechtigung zur Datenweitergabe</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-2">
                <li>Der Partner stellt sicher, dass er berechtigt ist, personenbezogene Daten, Fotos und Dokumente an den Anbieter zu übermitteln.</li>
                <li>Der Partner bestätigt, dass erforderliche Einwilligungen (z. B. vom Geschädigten/Fahrzeughalter) vorliegen.</li>
                <li>Der Partner lädt nur Daten hoch, die für die Bearbeitung notwendig sind.</li>
              </ol>
            </div>
          </section>
          
          {/* 6. Kommunikation */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Kommunikation und Rückfragen</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-2">
                <li>Wenn Angaben fehlen oder etwas unklar ist, nutzt der Anbieter das Rückfragen-System im Portal.</li>
                <li>Der Partner beantwortet Rückfragen zeitnah.</li>
                <li>Bleiben Rückfragen unbeantwortet, kann der Anbieter den Fall pausieren oder ablehnen.</li>
              </ol>
            </div>
          </section>
          
          {/* 7. Keine Zusagen */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Keine Zusagen gegenüber Endkunden</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-3">
                <li>
                  Der Partner macht gegenüber Endkunden keine verbindlichen Zusagen, insbesondere nicht zu:
                  <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                    <li>Erfolg oder Höhe einer Regulierung</li>
                    <li>festen Bearbeitungszeiten</li>
                    <li>garantierten Erstattungen oder Zahlungen</li>
                  </ul>
                </li>
                <li>Aussagen gegenüber Endkunden müssen sachlich bleiben und dürfen keine falschen Erwartungen wecken.</li>
              </ol>
            </div>
          </section>
          
          {/* 8. Restwert */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Restwert, Verwertung, Versteigerung</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-2">
                <li>Themen wie Restwert, Verwertung oder Versteigerung liegen grundsätzlich beim Partner bzw. beim Endkunden.</li>
                <li>Der Anbieter schuldet keine Durchführung einer Versteigerung oder Verwertung.</li>
                <li>Der Anbieter haftet nicht für erzielte Preise, Angebote von Dritten oder Verzögerungen in diesem Zusammenhang.</li>
              </ol>
            </div>
          </section>
          
          {/* 9. Annahme von Fällen */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Annahme von Fällen</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-3">
                <li>Der Anbieter entscheidet im Einzelfall, ob ein Fall angenommen wird.</li>
                <li>
                  Gründe für Ablehnung können z. B. sein:
                  <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                    <li>unvollständige Daten</li>
                    <li>widersprüchliche Angaben</li>
                    <li>Verdacht auf Vorschäden, Manipulation oder Missbrauch</li>
                    <li>Fall liegt außerhalb des Leistungsumfangs</li>
                  </ul>
                </li>
              </ol>
            </div>
          </section>
          
          {/* 10. Provisionsmodell */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Provisionsmodell</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-3">
                <li>Die Provision bezieht sich auf das Netto-Grundhonorar des jeweiligen Falls.</li>
                <li>
                  Grundlage ist das tatsächlich regulierte Netto-Grundhonorar nach Kürzungen.
                  <p className="ml-6 mt-2 text-sm italic">Beispiel: Netto-Grundhonorar minus Kürzung = regulierte Basis</p>
                </li>
                <li>
                  Die Provision wird nach folgendem Level berechnet:
                  <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                    <li><strong>Level 1: 30%</strong> (Start)</li>
                    <li><strong>Level 2: 40%</strong>, wenn der Partner mindestens 10 Fälle pro Monat einreicht und dies 3 Monate in Folge hält</li>
                    <li><strong>Level 3: 50%</strong>, wenn der Partner mindestens 20 Fälle pro Monat einreicht und dies 3 Monate in Folge hält</li>
                  </ul>
                </li>
                <li>Eine Einstufung oder Erhöhung erfolgt auf Basis der im System gezählten Fälle.</li>
              </ol>
            </div>
          </section>
          
          {/* 11. Auszahlung */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Auszahlung der Provision</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-2">
                <li>Eine Auszahlung erfolgt erst nach erfolgreicher Regulierung (Zahlungseingang) durch die Versicherung/den Zahler.</li>
                <li>Die Auszahlung erfolgt innerhalb von 7 Tagen, nachdem der Status im System auf „Auszahlung freigegeben" gesetzt wurde.</li>
                <li>Bei Streit, Rückbuchungen oder Unklarheiten kann die Auszahlung pausiert werden, bis der Sachverhalt geklärt ist.</li>
              </ol>
            </div>
          </section>
          
          {/* 12. Kein Anspruch */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Kein Anspruch auf Provision</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 mb-4">Ein Provisionsanspruch besteht nicht, wenn:</p>
              <ol className="list-decimal list-inside text-gray-700 space-y-2">
                <li>Angaben oder Fotos vorsätzlich falsch oder irreführend waren</li>
                <li>Vorschäden bewusst verschwiegen wurden</li>
                <li>der Fall nicht reguliert wird oder keine Zahlung eingeht</li>
                <li>der Fall abgebrochen werden muss, weil wichtige Mitwirkung fehlt</li>
              </ol>
            </div>
          </section>
          
          {/* 13. Haftung und Freistellung */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Haftung und Freistellung</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-2">
                <li>Der Partner haftet für Schäden, die durch falsche Angaben, fehlende Einwilligungen oder manipulierte Inhalte entstehen.</li>
                <li>Der Partner stellt den Anbieter von Ansprüchen Dritter frei, soweit diese auf dem Verhalten des Partners beruhen.</li>
              </ol>
            </div>
          </section>
          
          {/* 14. Vertraulichkeit */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Vertraulichkeit</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-2">
                <li>Portal-Inhalte, Prozesse, Dokumente und interne Hinweise sind vertraulich.</li>
                <li>Der Partner nutzt sie nur für die Zusammenarbeit und gibt sie nicht an Dritte weiter.</li>
              </ol>
            </div>
          </section>
          
          {/* 15. Kündigung und Sperrung */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">15. Kündigung und Sperrung</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-3">
                <li>Beide Seiten können die Zusammenarbeit beenden.</li>
                <li>
                  Der Anbieter kann den Zugang sofort sperren bei:
                  <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                    <li>Betrugsverdacht</li>
                    <li>wiederholten Falschangaben</li>
                    <li>Missbrauch des Systems</li>
                    <li>Verstößen gegen diese Bedingungen</li>
                  </ul>
                </li>
              </ol>
            </div>
          </section>
          
          {/* 16. Schlussbestimmungen */}
          <section className="pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">16. Schlussbestimmungen</h2>
            <div className="prose prose-lg">
              <ol className="list-decimal list-inside text-gray-700 space-y-2">
                <li>Es gilt deutsches Recht.</li>
                <li>Sollten einzelne Regelungen unwirksam sein, bleibt der Rest wirksam.</li>
                <li>Version: v1.0</li>
              </ol>
            </div>
          </section>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default PartnerbedingungenPage;
